import { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import UseAxios from '../../../Api/http/http';
import { getOpportunitiesOverview } from '../../../Api/request/staffAugmentation';
import PropTypes from 'prop-types';


export function useOpportunitiesOverview(initialDateRange) {
  const [opportunitiesRows, setOpportunitiesRows] = useState([]);
  const [opportunitiesDateRange, setOpportunitiesDateRange] = useState({
    startDate: initialDateRange.startDate,
    endDate: initialDateRange.endDate,
    label: initialDateRange.label,
  });
  const [opportunitiesPageSize, setOpportunitiesPageSize] = useState(20);

  const calculateTotals = (data) => {
    const totals = {
      id: 'Total', // Unique ID for the totals row
      verticalName: 'Total', // Label for the totals row
      totalPositions: data?.totalPositionCount,
      pendingPositions: data?.totalPendingPositionCount,
      closedPositions: data?.totalClosedPositionCount,
      lostPositions: data?.totalLostPositionCount,
      droppedPositions: data?.totalDroppedPositionCount,
    };
    return totals;
  };

  // API call to get opportunities overview list data
  const getOpportunitiesOverviewData = async (startDate, endDate, dealType) => {
    try {
      const response = await UseAxios(getOpportunitiesOverview(startDate, endDate, dealType));
      if (response?.status === 200) {
        const updatedDetails = Array.isArray(response?.data?.data?.opportunityOverviewDetails)
          ? response?.data?.data?.opportunityOverviewDetails.map((item, index) => ({
            ...item,
            id: index + 1, // Add a unique id starting from 1
          }))
          : [];

        let updatedDataWithTotals = [...updatedDetails];

        // Add totalsRow only if updatedDetails is not empty
        if (updatedDetails.length > 0) {
          const totalsRow = calculateTotals(response?.data?.data);
          updatedDataWithTotals = [...updatedDetails, totalsRow];
        }

        const numberOfRecords = updatedDataWithTotals?.length || 20;

        setOpportunitiesPageSize(numberOfRecords);
        setOpportunitiesRows(updatedDataWithTotals);
      } else {
        setOpportunitiesPageSize(20);
        setOpportunitiesRows([]);
      }
    } catch (error) {
      console.error('Failed to fetch opportunities overview data:', error);
      setOpportunitiesRows([]);
    }
  };

  useEffect(() => {
    getOpportunitiesOverviewData(
      opportunitiesDateRange?.startDate ? dayjs(opportunitiesDateRange?.startDate).format('YYYY-MM-DD') : '',
      opportunitiesDateRange?.endDate ? dayjs(opportunitiesDateRange?.endDate).format('YYYY-MM-DD') : '');
  }, []);

  return {
    opportunitiesRows,
    opportunitiesDateRange,
    setOpportunitiesDateRange,
    opportunitiesPageSize,
    getOpportunitiesOverviewData,
  };
}

useOpportunitiesOverview.propTypes = {
  initialDateRange: PropTypes.shape({
    startDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    endDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    label: PropTypes.string,
  }),
};
